import { AUDIO_SUB_TYPES, BILLING_CYCLE, planTypes, BASE_PLAN_SUB_TYPES, AUDIO_RATE_TYPES } from '@/common/constants';
import { flowTypes, pageConfig } from '@/common/service/page-config';
import { get, throttle } from 'lodash';
import { mapActions, mapGetters, mapMutations, mapState } from 'vuex';
import { ZOOM_MEETING_SUB_TYPES } from '@/plans/ZOOM_MEETING/common/utils'
import { unlimitedAudioRelatePlansGetter } from '@/common/service/audio-us-ca';

const HAS_UNLIMITED_TOLLFREE_PLAN_TYPES = [
  BASE_PLAN_SUB_TYPES.BIZ,
  BASE_PLAN_SUB_TYPES.EDUCATION,
  ZOOM_MEETING_SUB_TYPES.ZONE_EDU_SCH_CMP,
  BASE_PLAN_SUB_TYPES.ENTERPRISE,
  BASE_PLAN_SUB_TYPES.ENT,
];
const HAS_AUDIO_PAY_AS_YOU_GO_PLAN_TYPES = [
  BASE_PLAN_SUB_TYPES.BIZ,
  BASE_PLAN_SUB_TYPES.EDUCATION,
  BASE_PLAN_SUB_TYPES.BIZ_INR,
  BASE_PLAN_SUB_TYPES.ENTERPRISE,
  BASE_PLAN_SUB_TYPES.ENT,
  BASE_PLAN_SUB_TYPES.ZOOM_ONE_BIZ_PLUS,
  BASE_PLAN_SUB_TYPES.ZONE_EDU_PLUS,
  ZOOM_MEETING_SUB_TYPES.ZONE_EDU_SCH_CMP,
];

let messageBox = null;
export let defaultRegion = {
  [AUDIO_RATE_TYPES.TOLL_FREE]: "US",
  [AUDIO_RATE_TYPES.CALL_OUT]: "US",
  [AUDIO_RATE_TYPES.PREMIUM]: ""
}

let __isProactive = false;

export default {
  computed: {
    ...mapState({
      planMapFlat: (state) => state.ShoppingCart.planMapFlat,
    }),
    ...mapGetters([
      'getUserCurrentSubscriptions',
      'getSelectedPlans',
      'getCurrentBasePlanInfo',
      'boughtPlans',
      'unlimitedAudioLicense',
    ]),
    mx_basePlan() {
      return get(this.getCurrentBasePlanInfo, 'plans.0', {});
    },
    mx_basePlanName() {
      const basePlan = this.mx_basePlan || {};
      if (basePlan.planNameKey) return this.$t(basePlan.planNameKey);
      if (basePlan.typeNameKey) return this.$t(basePlan.typeNameKey);
      return '';
    },
    mx_basePlanCategory() {
      return get(this.getCurrentBasePlanInfo, 'plans.0.category', '');
    },
    mx_basePlanBillingCycle() {
      return get(this.getCurrentBasePlanInfo, 'plans.0.billing_cycle', '');
    },
    mx_getSelectedAudios() {
      return this.getSelectedPlans.filter(item => item.type === planTypes.TOLLFREE);
    },
    mx_getAudioPlans() {
      return this.planMapFlat.filter(item => item.type === planTypes.TOLLFREE);
    },
    mx_showUnlimited() {
      const cannotCoexistPlanTypes = [
        planTypes.ZOOM_UNITED,
        planTypes.ZOOM_ONE_BUNDLE,
      ];
      const hasCannotCoexistPlan = this.getUserCurrentSubscriptions.find(item => cannotCoexistPlanTypes.includes(item.type));
      const hasUnlimitedPlan = this.mx_getAudioPlans.find(item => item.category === AUDIO_SUB_TYPES.UNLIMITED);
      return (
        HAS_UNLIMITED_TOLLFREE_PLAN_TYPES.includes(this.mx_basePlan.zoomMeetingCategory) &&
        hasUnlimitedPlan &&
        !hasCannotCoexistPlan
      );
    },
    mx_showAudioPayYouGo() {
      if (pageConfig.type === flowTypes.edit) {
        const boughtPayYouGo = this.boughtPlans.find(item => (
          item.type === planTypes.TOLLFREE &&
          item.category === AUDIO_SUB_TYPES.TOLL_FREE &&
          item.billing_cycle === BILLING_CYCLE.PAY_AS_YOU_GO
        ))
        if (boughtPayYouGo) {
          return true;
        }
      }
      return HAS_AUDIO_PAY_AS_YOU_GO_PLAN_TYPES.includes(this.mx_basePlan.zoomMeetingCategory);
    },
    mx_hasUnlimitedPlan() {
      return !!this.mx_getSelectedAudios.find(item => item.category === AUDIO_SUB_TYPES.UNLIMITED);
    },
    mx_monthlyAudio() {
      const _monthlyAudio = this.mx_getAudioPlans.find(item => item.category === AUDIO_SUB_TYPES.TOLL_FREE && item.billing_cycle === BILLING_CYCLE.MONTHLY);
      return _monthlyAudio || {};
    },
    mx_selectedCategories() {
      return this.getSelectedPlans.filter(item => item.type === planTypes.TOLLFREE).map(item => item.category);
    },
    mx_boughtCategories() {
      return this.boughtPlans.filter(item => item.type === planTypes.TOLLFREE).map(item => item.category);
    },
    mx_newCategorys() {
      return this.mx_selectedCategories.filter(c => !this.mx_boughtCategories.includes(c));
    },
    mx_unlimitedBoughtRelatePlanTypes() {
      return this.boughtPlans.filter(item => [planTypes.ZOOM_MEETING, planTypes.ZOOM_ROOMS].includes(item.type)).map(item => item.type);
    },
    mx_unlimitedRelatePlans() {
      return unlimitedAudioRelatePlansGetter(this.getUserCurrentSubscriptions);
    },
  },
  methods: {
    ...mapMutations(['updateSelectPlan']),
    ...mapActions(['removePlanAction', 'switchSelectPlanAction']),
    // When base plan changed to biz. Need switch audio international to us&ca plan.
    mx_handleUnlimitedShow() {
      // If user can purchase US&CA Unlimited Audio, switch.
      const currentAudioPlan = this.mx_getSelectedAudios.find(item => item.category === AUDIO_SUB_TYPES.TOLL_FREE);
      if(!currentAudioPlan) return;
      const unlimitedPlans = this.mx_getAudioPlans
      .filter(item => item.category === AUDIO_SUB_TYPES.UNLIMITED);
      const defaultUnlimitedPlan = unlimitedPlans.find(item => item.billing_cycle === this.mx_basePlanBillingCycle) || unlimitedPlans[0];
      if(defaultUnlimitedPlan) {
        defaultUnlimitedPlan.cartInfo = { selected_number: this.unlimitedAudioLicense };
        this.switchSelectPlanAction([currentAudioPlan.plan_code, defaultUnlimitedPlan]);
      }
    },
    // When unlimited is hide, need remove unlimited plan.
    mx_handleUnlimitedHide() {
      const currentUnlimitedPlan = this.mx_getSelectedAudios.find(item => item.category === AUDIO_SUB_TYPES.UNLIMITED);
      const currentAudioPlan = this.mx_getSelectedAudios.find(item => item.category === AUDIO_SUB_TYPES.TOLL_FREE);
      // remove Unlimited Audio
      if(currentUnlimitedPlan) {
        this.removePlanAction(currentUnlimitedPlan.plan_code);
      }
      if(!currentAudioPlan) {
        this.mx_addAudioPlan(this.mx_monthlyAudio.plan_code, this.mx_monthlyAudio.billing_cycle);
      }
    },
    mx_handlePayYouGoHide() {
      const currentAudioPlan = this.mx_getSelectedAudios.find(item => item.category === AUDIO_SUB_TYPES.TOLL_FREE);
      if(currentAudioPlan && currentAudioPlan.billing_cycle === BILLING_CYCLE.PAY_AS_YOU_GO) {
        const cartInfo = { ...currentAudioPlan.cartInfo };
        currentAudioPlan && this.removePlanAction(currentAudioPlan.plan_code);
        this.mx_monthlyAudio && this.updateSelectPlan({
          ...this.mx_monthlyAudio,
          cartInfo,
        });
      }
    },
    getEduMeetingFromSelectedPlans() {
      return this.getSelectedPlans.find(sp => sp.category === BASE_PLAN_SUB_TYPES.EDUCATION && sp.type === planTypes.ZOOM_MEETING)
    },
    mx_handleUnlimitedLiceseChanged: throttle(function mx_handleUnlimitedLiceseChanged(newLicese) {
      const currentUnlimitedPlan = this.mx_getSelectedAudios.find(item => item.category === AUDIO_SUB_TYPES.UNLIMITED);
      if(!this.mx_showUnlimited) return;
      if(!currentUnlimitedPlan) return;
      if(!(this.$context.is.buyNow || this.$context.is.basic2pro || this.$context.is.add2cart)) return;
      const audioConferencingTitle = this.$t('billing.tollfree.audio_conferencing.title');
      const zoomOneTitle = this.$t('billing.planform.title.zoom_one')
      const ZoomEduTitle = this.$t('billing.planform.title.zoom_one_education')
      const ZoomRoomTitle = this.$t('billing.planform.title.zoomroom')
      let currentName = ''
      if (pageConfig?.editConfig?.planType === planTypes.ZOOM_ROOMS) {
        currentName = ZoomRoomTitle
      } else {
        currentName = this.getEduMeetingFromSelectedPlans() ? ZoomEduTitle : zoomOneTitle
      }

      let nameArr = [
        audioConferencingTitle,
        currentName
      ];
      if(__isProactive) {
        nameArr.reverse()
        __isProactive = false;
      }
      if(!messageBox) {
        messageBox = this.$message({
          message: this.$t('billing.tollfree.update_audio_license_tips', [...nameArr]),
          duration: 5000,
          iconClass: 'zm-icon-info',
          customClass: 'opc-message__info',
          showClose: true,
          onClose() { messageBox = null; },
        });
      }
      this.updateSelectPlan({
        ...currentUnlimitedPlan,
        cartInfo: { selected_number: newLicese },
      });
    }, 1000),
    mx_addAudioPlan(planCode, billingCycle) {
      this.updateSelectPlan({
        plan_code: planCode,
        planType: planTypes.TOLLFREE,
        billing_cycle: billingCycle,
        cartInfo: {
          selected_number: 1,
          tollFreeProfileData: {
            ...defaultRegion,
          },
        },
      });
    },
    mx_handleUnlimitedSelected() {
      defaultRegion = {
        [AUDIO_RATE_TYPES.TOLL_FREE]: "US,CA",
        [AUDIO_RATE_TYPES.CALL_OUT]: "US,CA",
        [AUDIO_RATE_TYPES.PREMIUM]: ""
      };
      const selectedIntenationalAudioPlan = this.mx_getSelectedAudios.find(item => item.category === AUDIO_SUB_TYPES.TOLL_FREE);
      if(selectedIntenationalAudioPlan) {
        const addRegion = (region, newCodes) => {
          const _region = region.split(',').filter(Boolean);
          newCodes.forEach(newCode => {
            if(!_region.includes(newCode)) return _region.push(newCode);
          });
          return _region.join(',')
        }
        const tollFreeProfileData = selectedIntenationalAudioPlan.cartInfo.tollFreeProfileData;
        this.updateSelectPlan({
          plan_code: selectedIntenationalAudioPlan.plan_code,
          planType: planTypes.TOLLFREE,
          billing_cycle: selectedIntenationalAudioPlan.billing_cycle,
          category: selectedIntenationalAudioPlan.category,
          cartInfo: {
            ...selectedIntenationalAudioPlan.cartInfo,
            tollFreeProfileData: {
              ...tollFreeProfileData,
              [AUDIO_RATE_TYPES.TOLL_FREE]: addRegion(tollFreeProfileData[AUDIO_RATE_TYPES.TOLL_FREE], ['US', 'CA']),
              [AUDIO_RATE_TYPES.CALL_OUT]: addRegion(tollFreeProfileData[AUDIO_RATE_TYPES.CALL_OUT], ['US', 'CA']),
            },
          },
        });
      }
    },
    mx_handleUnlimitedLicenseClick() {
      __isProactive = true;
    },
  },
  watch: {
    // Need to check base plan change.
    mx_showUnlimited(value, oldValue) {
      if(!this.mx_getSelectedAudios.length) return;
      if(oldValue === value) return;
      // if(value) return this.mx_handleUnlimitedShow();
      if(!value) return this.mx_handleUnlimitedHide();
    },
    // Need to check base plan change.
    mx_showAudioPayYouGo(value, oldValue) {
      if(!this.mx_getSelectedAudios.length) return;
      if(oldValue === value) return;
      if(!value) return this.mx_handlePayYouGoHide();
    },
    // US & CA Audio license should match with Zoom Meetings + Zoom Rooms.
    unlimitedAudioLicense(value, oldValue) {
      if(!this.mx_getSelectedAudios.length) return;
      if(value !== oldValue) return this.mx_handleUnlimitedLiceseChanged(value);
    },
    mx_hasUnlimitedPlan(value, oldValue) {
      if(value && !oldValue) {
        this.mx_handleUnlimitedSelected();
      }
    }
  },
}
